import { render, staticRenderFns } from "./echart-bar.vue?vue&type=template&id=996b915e&scoped=true&"
import script from "./echart-bar.vue?vue&type=script&lang=js&"
export * from "./echart-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996b915e",
  null
  
)

export default component.exports